export default {
  cookies: {
    weUseCookies: 'We Use Cookies In The Delivery Of Our Services.',
    learnMoreStart: 'To learn about the cookies we use and information about your preferences and opt-out-choices, please ',
    learnMoreClickHere: 'click here',
    learnMoreEnd: '.',
    decline: 'Decline',
    allow: 'Allow',
    showPrivacyPolicy: 'Show privacy policy'
  }
};